<template>
  <div class="sound" >
    <audio v-if="BGM" id="sound-all-bgm" ref="editorBGM"  :src="$handleAssetsUrl(BGM.data.url)"/>
    <audio v-if="allSound" id="sound-all-record" ref="editorAllSound"  :src="$handleAssetsUrl(allSound.data.url)"/>
    </audio>
    <div v-for="(item, index) in soundData">
      <audio v-if="item.data.url" :data-id="item.id" :src="item.data.url" ref="scenesSound">
      </audio>
    </div>
    <div v-for="(item) in spriteSoundURL">
      <audio v-if="item.id" :data-id="item.id" :src="item.url" ref="spritesound">
      </audio>
    </div>
  </div>
</template>

<script>
//  音乐播放组件
import { mapGetters } from 'vuex'
// eve('playByFrame', null, 1, TOOL.getSelectScenes().id)
export default {
  data() {
    return {
      BGM          : null, // 全局bgm
      allSound     : null,
      soundData    : [],   // 音乐数据
      selectScenes : null, // 选中的分组
      toSound      : false,
      lastRunTime  : 0,
      spriteSound  : [],   // 有声元素列表
      spriteSoundURL : {
        c : 0,
      }, // 资源url
      hintMessage  : false,// 项目加载完成
      spriteSoundJudge  : false,
    };
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'UserEquity',
    ])
  },
  watch : {
    'TOOL.sound.url'       : function(){            // 监控bgm改变
      if(this.TOOL.sound && this.TOOL.sound.url){
        let TOOLData = this.TOOL.toJson(),
            Turl     = TOOLData.sound[0],
            Burl     = this.BGM;
        this.BGM = {
          data : {
            endTime    : this.TOOL.sound.endTime * 1000,
            startTime  : this.TOOL.sound.startTime * 1000,
            volume     : this.TOOL.sound.volume,
            fileType   : this.TOOL.sound.fileType,
            isLoop     : this.TOOL.sound.isLoop,
            resourceId : this.TOOL.sound.resourceId,
            subtitle   : this.TOOL.sound.subtitle,
            url        : this.$handleAssetsUrl(this.TOOL.sound.url),
          },
          sound : this.$refs.editorBGM,
        }
        this.scenesSound();
        if(this.BGM.sound){
          this.judgeSoundLoadFs(Turl, Burl);
          if(this.BGM.data.volume){
            let volume = ((this.BGM.data.volume-0) / 100);
                volume = volume > 1 ? 1 : (volume < 0 ? 0: volume);
            this.BGM.sound.volume = volume;
          }else{
            this.BGM.sound.volume = 0;
          }
        }else{
          let timeoutid = setTimeout(() => {
            this.BGM.sound = this.$refs.editorBGM;
            this.judgeSoundLoadFs(Turl, Burl);
            clearTimeout(timeoutid);
          });
        }
        this.$store.commit('del_vipSprites', {id : 'TOOLsound'});

        let timeoutid = setTimeout(() => {
          this.$bus.emit('judgeItemPayType_vue',{
            type     : 'sound',
            id       : 'TOOLsound',
            option   : {
              resourceId  : this.BGM.data.resourceId,      // 背景资源id
              fileType    : this.BGM.data.fileType,// 背景资源type
            },
            opHelper : {
              isSvip : false,
            },
            scenesId :  'TOOLsound'
          });
          clearTimeout(timeoutid);
        });
      }else{
        this.BGM = null;
        this.$store.commit('del_vipSprites', {id : 'TOOLsound'});
      }
    },
    'TOOL.sprites'     : function(val, oldval){ // 加载分组音乐
      if(this.TOOL.sprites.length){
        this.scenesSound();
      }
    },
    'TOOL.soundRecord' : function(val, oldval){ // 加载分组音乐
      if(val){
        this.soundData = [];
        let AllSound = this.TOOL.getSoundRecord(),
            Turl     = AllSound,
            Burl     = this.allSound;
        this.allSound = {
          data : {
            endTime    : AllSound.endTime * 1000,
            startTime  : AllSound.startTime * 1000,
            volume     : AllSound.volume,
            fileType   : AllSound.fileType,
            isLoop     : AllSound.isLoop,
            resourceId : AllSound.resourceId,
            subtitle   : AllSound.subtitle,
            url        : this.$handleAssetsUrl(AllSound.url),
          },
          sound : this.$refs.editorAllSound,
        }
        if(this.allSound.sound){
          this.judgeSoundLoadFs(Turl, Burl, 1);
          if(this.allSound.data.volume){
            let volume = ((this.allSound.data.volume-0) / 100);
                volume = volume > 1 ? 1 : (volume < 0 ? 0: volume);
            this.allSound.sound.volume = volume;
          }else{
            this.allSound.sound.volume = 0;
          }
        }else{
          let timeoutid = setTimeout(() => {
            this.allSound.sound = this.$refs.editorAllSound;
            this.judgeSoundLoadFs(Turl, Burl, 1);
            clearTimeout(timeoutid);
          });
        }

      } else {
        this.allSound = null;
        this.scenesSound();
      }
    },
    'SelectScenes_Msg.sound' : function(val, oldval){ // 加载分组音乐
      if(this.SelectScenes_Msg.sound){
        this.allSound = null;
        this.scenesSound();
      }else{
        for(let i=0; i < this.soundData.length; i++){
          if(this.soundData[i].id === this.SelectScenes_Msg.id){
            this.soundData.splice(i, 1);
            if(this.selectScenes && this.selectScenes.id === this.SelectScenes_Msg.id){
              this.selectScenes = null;
              // console.log(this.soundData, 'soundData', this.selectScenes, 'selectScenes')
            }
          }
        }
      }
      if(!this.SelectScenes_Msg.sound || !this.SelectScenes_Msg.sound.url){
        this.$store.commit('del_vipSprites', {id : 'ScenesSound' + this.SelectScenes_Msg.id});
      }
    },
    'SelectScenes_Msg.duration' : function(val, oldval){ // 加载分组音乐
      if(this.SelectScenes_Msg.duration){
        this.scenesSound();
      }
    },
    'SelectScenes_Msg.id' : function(val, oldval){ // 加载分组音乐
      if(this.SelectScenes_Msg){
        this.stopMusic();
        this.$bus.emit('timeline_play_stop', {isPlay : false});
      }
    },
    'SelectScenes_Msg.sprites': function(){            // 监控bgm改变
      let timeoutide = setTimeout(() => {
        this.collectSpriteSound();
        clearTimeout(timeoutide);
      }, 300)
    },
    'hintMessage': function(){            // 监控bgm改变

    },
    'TOOL' (val) {
      const vm = this;
      if (val) {
        val.eve.on('playByFrame', (frame, sceneId) => {
        let time = frame / this.TOOL.option.frameRate,
            scenesList = this.TOOL.sprites;

        for(var i = 0; i < scenesList.length; i++){
            if(scenesList[i].id !== sceneId ){
                time += (scenesList[i].getDuration() / 1000);
            } else if( scenesList[i].id == sceneId ){
                break;
            }
        }
        vm.playSpriteSound(time, sceneId);
        this.playingTime = time;
      })
      }
    }
  },
  created () {
    eve.on('sceneSprite.unLoadData.fromJsonLoadingState', data => {
      this.collectSpriteSound();
    })
  },
  mounted () {
    this.$bus.on("timeline_play_scenes",(data) => {   // 分组播放
      if(data.isPlay){
        this.isGlobalPlay = false;
        this.spriteSoundJudge = true;
        let newTime = Date.now();
        if(this.lastRunTime && (newTime - this.lastRunTime ) < 100){
          // console.log('dianja', newTime, this.lastRunTime)
          this.lastRunTime = newTime;
          return; // 防止频繁点击
        }else{
          this.lastRunTime = newTime;
        }

        // 开始时间
        let bgmIndex = this.SelectScenes_Msg.index,
            oldTime  = 0;
        for(let i = 0; i < bgmIndex ; i++){
          let time = this.TOOL.sprites[i];
          if(time){
            oldTime += (time.getDuration());
          }
        }
        oldTime += (data.nowTime * 1000);
        this.loadingBGM(oldTime);
        this.loadingScenesSound(oldTime);
        this.toSound = true;
      }else{
        this.stopMusic();
      }
    });
    this.$bus.on("timeline_play_all",(data) => {   // 全局播放
      this.isGlobalPlay = true;
      this.stopMusic();
      if(data.isPlay && !data.noMusic){
        this.spriteSoundJudge = true;
        this.loadingBGM(data.time);
        this.loadingScenesSound(data.time);
      }
    });
    this.$bus.on("switch_scenes_play",(data) => {   // 切换分组
      if(this.selectScenes && this.selectScenes.sound){
        this.selectScenes.sound.pause();
      }
      if(data.id){
        this.loadingScenesSound(data.time);
      }
    });
    this.$bus.on("volume_sound_play",(data) => {   // 音量控制

      let volume = ((data.volume-0) / 100);
      if(this.BGM && this.BGM.sound){
        let toolVolume = ((this.BGM.data.volume*volume) / 100);
            toolVolume = toolVolume > 1 ? 1 : (toolVolume < 0 ? 0: toolVolume);
        this.BGM.sound.volume = toolVolume;
      }
      if(this.selectScenes){
        let scenesVolume = ((this.selectScenes.data.volume * volume) / 100);
            scenesVolume = scenesVolume > 1 ? 1 : (scenesVolume < 0 ? 0: scenesVolume);
        this.selectScenes.sound.volume = scenesVolume;
      }
    });

    this.$bus.on("scenes_soundUpdata_vue",(data) => {   // 音量控制
      if(this.SelectScenes_Msg.sound){
        this.scenesSound();
      }
      if(this.allSound && this.TOOL.soundRecord){
        this.allSound.data.volume = this.TOOL.soundRecord.volume;
      }
    });
    this.$bus.on('spritesFlagChange', () => {      // formjson所有信息
      this.collectSpriteSound();
    });

    this.$bus.on('spritesExitChange', () => {      // formjson所有信息
      let timeoutide = setTimeout(() => {
        this.collectSpriteSound();
        clearTimeout(timeoutide);
      }, 100)
    });
  },
  methods: {
    scenesSound(){      // 加载所有分组音乐资源
      this.soundData = [];
      for(let i = 0; i < this.TOOL.sprites.length ; i++){
        if(this.TOOL.sprites[i].sound && this.TOOL.sprites[i].sound.url){ // 加载所有音乐dom元素
          let scenesData = this.TOOL.sprites[i].toJson();

          let scenesSound = scenesData.sound[0].url;
          scenesSound = scenesSound.indexOf("http") != -1 ? scenesSound : (this.$handleAssetsUrl(scenesSound));

          let time = {
            data      : {    // sound数据
              endTime    : scenesData.sound[0].endTime * 1000,
              startTime  : scenesData.sound[0].startTime * 1000,
              volume     : scenesData.sound[0].volume,
              fileType   : scenesData.sound[0].fileType,
              isLoop     : scenesData.sound[0].isLoop,
              resourceId : scenesData.sound[0].resourceId,
              subtitle   : scenesData.sound[0].subtitle,
              url        : scenesSound,
            },
            id        : this.TOOL.sprites[i].id,        // scenes id
            duration  : this.TOOL.sprites[i].duration,  // 分组时间长度
            startTime : 0,                              // 分组音乐启动时间
            endTime   : 0,
            sound     : null,                           // 分组音乐dom
            alltime   : 0,                              // 分组音乐时间
          };
          scenesData = null;
          for(let t = 0; t < this.TOOL.sprites[i].index; t++){
            let duration = this.TOOL.sprites[t].getDuration();
            if(duration){
              time.startTime += (duration);
            }
          }
          time.endTime = time.startTime + time.duration;
          this.soundData.push(time);
        }
      }
      // console.log(this.soundData, '加载所有分组音乐资源-----------------')
    },
    loadingScenesSound(data){ // 单个分组播放的函数
      if(this.allSound)return;
      if(this.soundData.length && !this.soundData[0].sound){  // 获取赋值所有音乐dom元素
        for(let i = 0; i < this.soundData.length ; i++){
          let soundDom = this.$refs.scenesSound;

          if(soundDom && soundDom.length){

            for(let t = 0; t < soundDom.length ; t++){

              if(this.soundData[i].id === soundDom[t].dataset.id){
                this.soundData[i].sound   = soundDom[t];
                this.soundData[i].alltime = this.soundAllTime(soundDom[t]);
                break;
              }
            }
          }
        }
      }
      this.selectScenes = null;
      if(this.soundData.length){ // 判断是那个分组播放，然后进行顺序播放
        for(let m = 0; m < this.soundData.length ; m++){
          if(this.soundData[m+1] && this.soundData[m].startTime <= data ){
            if(this.soundData[m].duration > data ){
              this.selectScenes = this.soundData[m];
              break;
            }else if(this.soundData[m+1] && this.soundData[m+1].startTime > data && this.soundData[m].endTime >= data){
              this.selectScenes = this.soundData[m];
              break;
            }
          }else{
            if(this.soundData[m].startTime <= data && (this.soundData[m].startTime + this.soundData[m].duration) > data ){
              this.selectScenes = this.soundData[m];
              // 判断是那个分组播放，不存在下级元素
              break;
            }
          }
        }
      }
      if(this.selectScenes && this.selectScenes.sound){
        // console.log(data, '000', this.selectScenes.startTime, this.selectScenes.sound.duration)
        let scenesSoundAllTime = this.selectScenes.startTime + (this.selectScenes.sound.duration * 1000);
        if(data > scenesSoundAllTime)return;
        // 时间
        if(data){
          data = data - this.selectScenes.startTime;
          data = data/1000;
          if(data > this.selectScenes.allTime){
            data = this.selectScenes.data.isLoop ? (Math.floor((data%this.selectScenes.allTime) * 100) / 100) : this.selectScenes.allTime
          }else{
            data = data;
          }
        }
        this.selectScenes.sound.currentTime =  (data) || 0;


        // 分组音乐播放开始时间（需要判断是否会循环）
        if(this.selectScenes.data.startTime){
          this.selectScenes.sound.currentTime += (this.selectScenes.data.startTime/1000);
        }

        // 音量
        if(this.selectScenes.data.volume){
          let volume = ((this.selectScenes.data.volume-0) / 100);
              volume = volume > 1 ? 1 : (volume < 0 ? 0: volume);
          this.selectScenes.sound.volume = volume;
        }else{
          this.selectScenes.sound.volume = 0;
        }
        // console.log(this.selectScenes.sound.volume, this.selectScenes.data)
        this.selectScenes.sound.play();

        if(this.selectScenes.sound.readyState != 1){
          this.$message({
            showClose: true,
            message: '当前网络环境较差，暂时无法支持预览时播放音乐。（此情况不影响视频正常导出）。',
            type: 'error'
          });
        }
        this.selectScenes.sound.addEventListener("timeupdate",()=>{  // 实时监听音乐播放
          if(!this.selectScenes || !this.selectScenes.sound){
            return;
          }
          this.$bus.emit("SoundScenesCurrentTime",{time: this.selectScenes.sound.currentTime})
          if(this.selectScenes.sound && (this.selectScenes.sound.currentTime + 0.05) >= (this.selectScenes.sound.duration)){
            if(this.selectScenes.data.isLoop){
              this.selectScenes.sound.currentTime = (this.selectScenes.data.startTime/1000);
              this.selectScenes.sound.play();
            }else{
              // console.log(this.selectScenes.sound.currentTime, '判断是那个分组播放，然后进行顺序播放')
              this.selectScenes.sound.pause();
            }
          }
        });

      }else{
        // 无分组音乐播放
      }
    },
    addEndedEvent () {
      const vm = this;
      let h1 = () => {
        let sound = vm.BGM;
        if (vm.TOOL.sound && vm.TOOL.sound.isLoop && vm.BGM) {
          sound.sound.currentTime = 0;
          sound.sound.play();
        }
      }

      let h2 = () => {
        let sound = vm.allSound;
        if (vm.TOOL.soundRecord && vm.TOOL.soundRecord.isLoop && vm.allSound) {
          sound.sound.currentTime = 0;
          sound.sound.play();
        }
      }

      if (this.BGM && this.BGM.sound) {
        this.BGM.sound.removeEventListener('ended', h1);
        this.BGM.sound.addEventListener('ended', h1);

      }
      if (this.allSound && this.allSound.sound) {
        this.allSound.sound.removeEventListener('ended', h2);
        this.allSound.sound.addEventListener('ended', h2);
      }
    },
    loadingBGM(data){   // 加载背景bgm
      this.addEndedEvent();

      if(this.allSound){
        if(!this.allSound.sound){
          this.allSound.sound = this.$refs.editorBGM;
        }

        // 游标所在的时间点
        let allSoundData = data/1000;
        if(allSoundData){
          let allTimeSE = this.allSound.data.startTime/1000; // 开始时间

          if(allTimeSE && allTimeSE > 0){
            allSoundData = allTimeSE + allSoundData;
          }else{
            allSoundData = allSoundData + (this.allSound.data.startTime/1000);
          }
        }
        this.allSound.sound.currentTime =  allSoundData || 0;
        let judgePlay = true;
        if(this.allSound.sound.duration < allSoundData){
          if(this.allSound.data.isLoop){
            this.allSound.sound.currentTime =  allSoundData%this.allSound.sound.duration || 0;
          }else{
            judgePlay = false;
          }
        }
        // console.log(this.allSound.sound.currentTime, data);
        // 分组播放的音乐所在时间（需要判断是否会循环）
        if(judgePlay){

          if(this.allSound.data.startTime && !allSoundData){
            this.allSound.sound.currentTime = (this.allSound.data.startTime/1000);
          }
          // 音量
          if(this.allSound.data.volume){
            let volume = ((this.allSound.data.volume-0) / 100);
                volume = volume > 1 ? 1 : (volume < 0 ? 0: volume);
            this.allSound.sound.volume = volume;
          }else{
            this.allSound.sound.volume = 0;
          }

          if(this.allSound.sound.readyState != 1){
            this.$message({
              showClose: true,
              message: '当前网络环境较差，暂时无法支持预览时播放音乐。（此情况不影响视频正常导出）。',
              type: 'error'
            });
          }
          this.allSound && this.allSound.sound.addEventListener("timeupdate", ()=>{  // 实时监听音乐播放
            if(this.allSound.sound && this.allSound.sound.currentTime && (this.allSound.sound.currentTime + 0.05) >= (this.allSound.sound.duration)){
              if(this.allSound.data.isLoop){
                this.allSound.sound.currentTime = (this.allSound.data.startTime/1000);
                this.allSound.sound.play();
              }else{
                this.allSound.sound.pause();
              }
            }else{
            }

            if(this.allSound.sound){
              this.$bus.emit("SoundScenesCurrentTime",{time: this.allSound.sound.currentTime})
            }
          });

          if (this.isGlobalPlay) {
            this.allSound.sound.play();
          } else {
            if (this.TOOL.soundRecord.isLoop) {
              this.allSound.sound.play();
            } else {
              let globalTime = getGlobalTime.call(this);
              globalTime < this.allSound.sound.duration && this.allSound.sound.play();
            }
          }

        }
      }
      if(this.TOOL.sound && this.TOOL.sound.url){
        if(!this.BGM.sound){
          this.BGM.sound = this.$refs.editorBGM;
        }

        // 游标所在的时间点
        data = data/1000;
        let toolSoundData = this.TOOL.getSound();
        if(data){
          let allTimeSE = this.TOOL.sound.startTime/1000; // 开始时间

          if(allTimeSE && allTimeSE > 0){
            data = allTimeSE + data;
          }else{
            data = data + (this.TOOL.sound.startTime/1000);
          }
        }
        this.BGM.sound.currentTime =  data || 0;

        // 分组播放的bgm所在时间（需要判断是否会循环）
        if(this.TOOL.sound.startTime && !data){
          this.BGM.sound.currentTime = (this.TOOL.sound.startTime/1000);
        }
        // 音量
        if(this.BGM.data.volume){
          let volume = ((this.BGM.data.volume-0) / 100);
              volume = volume > 1 ? 1 : (volume < 0 ? 0: volume);
          this.BGM.sound.volume = volume;
        }else{
          this.BGM.sound.volume = 0;
        }

        if(this.BGM.sound.readyState != 1){
          this.$message({
            showClose: true,
            message: '当前网络环境较差，暂时无法支持预览时播放音乐。（此情况不影响视频正常导出）。',
            type: 'error'
          });
        }

        let startTime = this.TOOL.sound.startTime ? this.TOOL.sound.startTime / 1000 : 0;
        let endTime = this.TOOL.sound.endTime ? this.TOOL.sound.endTime / 1000 : this.BGM.sound.duration + startTime;
        let toolSoundDataFS = ()=>{  // 实时监听音乐播放
          // console.log(data, '<----开始------------------时间', this.BGM);
          this.$bus.emit("SoundBGCurrentTime",{time: this.BGM.sound.currentTime});
          if(this.BGM.sound && (this.BGM.sound.currentTime >= endTime || this.BGM.sound.currentTime <= startTime)){
            if(this.TOOL.sound.isLoop){
              // let sceneTime = this.TOOL.selectedScenes.nowTime;
              // let beforeSceneTime = 0;
              // for (let i = 0; i < this.TOOL.selectedScenes.index; i++) {
              //   beforeSceneTime += this.TOOL.sprites[i].duration / 1000;
              // }
              // let globalTime = sceneTime + beforeSceneTime;
              let partDur = endTime - startTime;
              let shim = this.playingTime % partDur;
              this.BGM.sound.currentTime = (this.TOOL.sound.startTime/1000) + shim;
              // this.BGM.sound.removeEventListener('timeupdate', toolSoundDataFS);
            }else{
              this.BGM.sound.pause();
              this.BGM.sound.removeEventListener('timeupdate', toolSoundDataFS);
              // console.log(this.BGM, '<----背景音乐---停止', this.BGM.sound.currentTime, '<---currentTime',this.BGM, '>' )
            }
          }
        };
        this.toolSoundDataFS = this.toolSoundDataFS || toolSoundDataFS;
        this.BGM.sound.volume = this.TOOL.sound.volume / 100;
        this.BGM.sound.removeEventListener("timeupdate", this.toolSoundDataFS);
        this.BGM.sound.addEventListener("timeupdate", this.toolSoundDataFS);

        if (this.isGlobalPlay) {
          this.BGM.sound.play();
        } else {
          if (this.TOOL.sound.isLoop) {
            this.BGM.sound.play();
          } else {
            let globalTime = getGlobalTime.call(this);
            globalTime < this.BGM.sound.duration && this.BGM.sound.play();
          }
        }
        // console.log(this.BGM, '<----背景音乐播放')
      }

      function getGlobalTime () {
        let sceneTime = this.TOOL.selectedScenes.nowTime;
        let beforeSceneTime = 0;
        for (let i = 0; i < this.TOOL.selectedScenes.index; i++) {
          beforeSceneTime += this.TOOL.sprites[i].duration / 1000;
        }
        let globalTime = sceneTime + beforeSceneTime;
        return globalTime
      }
    },
    stopMusic(){        // 停止播放音乐
      this.spriteSoundJudge = false;
      if(this.BGM){
        if(this.BGM.sound && !this.BGM.sound.paused){
          this.BGM.sound.pause();
        }
      }
      if(this.allSound){
        if(this.allSound.sound && !this.allSound.sound.paused){
          this.allSound.sound.pause();
        }
      }
      if(this.soundData.length){
        for(let i = 0; i < this.soundData.length ; i++){
            // 分组音乐停止
          if(this.soundData[i].sound && !this.soundData[i].sound.paused){
            this.soundData[i].sound.pause();
          }
        }
      }

      this.$bus.emit("stop_sound_vue",{type: true})   // 分组播放
      let timeoutid = setTimeout(() => {
        this.$bus.emit("SoundBGCurrentTime",{time: 0});
        this.$bus.emit("SoundScenesCurrentTime",{time: 0});

        for(let i = 0; i < this.spriteSound.length; i++){
          // 分组音乐停止
          if(this.spriteSound[i].soundDom && !this.spriteSound[i].soundDom.paused){
            this.spriteSound[i].soundDom.pause();
          }
        }
        clearTimeout(timeoutid);
      });
    },
    soundAllTime(data){ // 传入音乐dom
      // bgm时长
        let time = data.duration;
        //分钟
        let minute = time / 60;
        let minutes = parseInt(minute);
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        //秒
        let second = time % 60;
        let seconds = Math.round(second);
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        //总共时长的秒数
        let allTime = parseInt(minutes*60 + seconds);
        return allTime;
    },
    judgeSoundLoadFs(Turl, Burl, step){
      if(Turl && Burl && Turl.url == Burl.data.url) return;

      this.TOOL.loading.status = 'loading';
      if(step == 1){
        this.allSound.sound.addEventListener("canplaythrough", () => {
          this.TOOL.loading.status = 'success';
        });
      }else{
        this.BGM.sound.addEventListener("canplaythrough", () => {
          this.TOOL.loading.status = 'success';
        });
      }
    },
    collectSpriteSound(){ // 收集所有的有声素材
      this.spriteSound = [];

      for(let i = 0; i < this.TOOL.sprites.length; i++){
        if(this.TOOL.sprites[i].fromJsonLoadingState !==2 ) continue;
        let spritesList = this.TOOL.sprites[i].sprites;
        for(var z = 0; z < spritesList.length; z++){

          let sprite = spritesList[z];
          if(sprite.sound){
            let soundData = sprite.getSound();
            soundData.id  = sprite.id;
            soundData.scenesId = sprite.scenesId;
            this.spriteSoundURL[soundData.id] = {
              url : this.$handleAssetsUrl(soundData.url),
              id  : sprite.id,
            }
            this.spriteSound.push( soundData );
          }
        }
      }

      this.spriteSoundURL.c += 2;

      this.$nextTick(() => {
        let soundDomList = this.$refs.spritesound;
        if(!soundDomList)return;
        for(let i = 0; i < soundDomList.length; i++){
          let dataId = soundDomList[i].dataset.id;
          soundDomList[i].load();
          this.spriteSoundURL[dataId].soundDom = soundDomList[i];
        }

        for(let i = 0; i < this.spriteSound.length; i++){
          this.spriteSound[i].soundDom = this.spriteSoundURL[ this.spriteSound[i].id ].soundDom;
        }
      })
    },
    playSpriteSound(time, sceneId){  // 有声素材音乐播放
      for(let i = 0; i < this.spriteSound.length; i++){

        let timeData = this.TOOL.getSpriteIdData(this.spriteSound[i].id);
        if(timeData){

          timeData = timeData.getSound();
          let sprite   = this.spriteSound[i],
              playtime = 0;

          sprite.endTime   = timeData.endTime;
          sprite.startTime = timeData.startTime;
          sprite.volume    = timeData.volume;
          let timeupdateFS = () => {
            if(sprite.soundDom.currentTime >= timeData.aduration){
              // console.log('停止音乐', sprite.soundDom.currentTime, timeData.aduration);
              sprite.soundDom.currentTime = 0;
              // sprite.soundDom.play();
            }
          };
          if(sprite.scenesId == sceneId && sprite.soundDom){

            let duration = timeData.aduration;
            if(time >= sprite.startTime && time < sprite.endTime ){

              let actionTime = time - sprite.startTime;
              let lottieTime = actionTime % timeData.aduration;
              if(lottieTime < timeData.duration){

                if(sprite.soundDom.paused){
                  playtime = (time - sprite.startTime) % duration;
                  sprite.soundDom.currentTime = playtime;

                  let volume = ((sprite.volume-0) / 100);
                  volume = volume > 1 ? 1 : (volume < 0 ? 0: volume);
                  sprite.soundDom.volume = volume;

                  if(this.spriteSoundJudge){
                    sprite.soundDom.play();

                    if(sprite.soundDom.duration > timeData.aduration){

                      sprite.soundDom.addEventListener("timeupdate", timeupdateFS);
                    }
                  }
                }
              }
            }else{
              sprite.soundDom.pause();
              sprite.soundDom.removeEventListener("timeupdate", timeupdateFS)
            }
          }else if(sprite.soundDom){
            sprite.soundDom.pause();
            sprite.soundDom.removeEventListener("timeupdate", timeupdateFS)
          }
        }
      }
    },
  },
  components: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .sound{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 30;
    width: 0;
    height: 0;
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sound.vue